/**
 * Types for External Content feature - video/audio uploads from external sources.
 */
// Mirrors ExternalContentSortEnum.java.
export var SortOption;
(function (SortOption) {
    SortOption["RECENT"] = "RECENT";
    SortOption["OLDEST"] = "OLDEST";
    SortOption["ALPHABETICAL"] = "ALPHABETICAL";
    SortOption["SOURCE_DATE_NEWEST"] = "SOURCE_DATE_NEWEST";
    SortOption["SOURCE_DATE_OLDEST"] = "SOURCE_DATE_OLDEST";
    SortOption["LARGEST"] = "LARGEST";
    SortOption["SMALLEST"] = "SMALLEST";
})(SortOption || (SortOption = {}));
// Mirrors ExternalContentMode.java.
export var ContentMode;
(function (ContentMode) {
    ContentMode["SINGLE_SPEAKER"] = "SINGLE_SPEAKER";
    ContentMode["CONVERSATION"] = "CONVERSATION";
})(ContentMode || (ContentMode = {}));
// Mirrors ExternalContentStatus.java.
export var ContentStatus;
(function (ContentStatus) {
    ContentStatus["INGESTING"] = "INGESTING";
    ContentStatus["TRANSCODING"] = "TRANSCODING";
    ContentStatus["PROBING"] = "PROBING";
    ContentStatus["WAITING_FOR_METADATA"] = "WAITING_FOR_METADATA";
    ContentStatus["BALANCE_CHECK"] = "BALANCE_CHECK";
    ContentStatus["EXTRACTING_AUDIO"] = "EXTRACTING_AUDIO";
    ContentStatus["DIARIZING"] = "DIARIZING";
    ContentStatus["BALANCE_DEDUCTION"] = "BALANCE_DEDUCTION";
    ContentStatus["ANALYZING"] = "ANALYZING";
    ContentStatus["COMPLETE"] = "COMPLETE";
})(ContentStatus || (ContentStatus = {}));
export var UploadFileStatus;
(function (UploadFileStatus) {
    UploadFileStatus["PENDING"] = "pending";
    UploadFileStatus["UPLOADING"] = "uploading";
    UploadFileStatus["COMPLETE"] = "complete";
    UploadFileStatus["ERROR"] = "error";
})(UploadFileStatus || (UploadFileStatus = {}));
export var StatusSortOrder;
(function (StatusSortOrder) {
    StatusSortOrder[StatusSortOrder["INGESTING"] = 0] = "INGESTING";
    StatusSortOrder[StatusSortOrder["TRANSCODING"] = 1] = "TRANSCODING";
    StatusSortOrder[StatusSortOrder["PROBING"] = 2] = "PROBING";
    StatusSortOrder[StatusSortOrder["WAITING_FOR_METADATA"] = 3] = "WAITING_FOR_METADATA";
    StatusSortOrder[StatusSortOrder["BALANCE_CHECK"] = 4] = "BALANCE_CHECK";
    StatusSortOrder[StatusSortOrder["EXTRACTING_AUDIO"] = 5] = "EXTRACTING_AUDIO";
    StatusSortOrder[StatusSortOrder["DIARIZING"] = 6] = "DIARIZING";
    StatusSortOrder[StatusSortOrder["BALANCE_DEDUCTION"] = 7] = "BALANCE_DEDUCTION";
    StatusSortOrder[StatusSortOrder["ANALYZING"] = 8] = "ANALYZING";
    StatusSortOrder[StatusSortOrder["COMPLETE"] = 9] = "COMPLETE";
})(StatusSortOrder || (StatusSortOrder = {}));
export var SpeakerRole;
(function (SpeakerRole) {
    SpeakerRole["Host"] = "HOST";
    SpeakerRole["Attendee"] = "ATTENDEE";
})(SpeakerRole || (SpeakerRole = {}));
// Which edit triggered the removal confirmation, selecting its warning copy + title.
export var ExcerptRemovalEdit;
(function (ExcerptRemovalEdit) {
    ExcerptRemovalEdit["Role"] = "role";
    ExcerptRemovalEdit["Reassign"] = "reassign";
})(ExcerptRemovalEdit || (ExcerptRemovalEdit = {}));
const isExcerptRemovalConflictDetails = (details) => typeof details === "object" &&
    details !== null &&
    typeof details.excerptsToRemove === "number";
export const isExcerptRemovalConflict = (error) => typeof error === "object" &&
    error !== null &&
    "statusCode" in error &&
    error.statusCode === 409 &&
    "details" in error &&
    isExcerptRemovalConflictDetails(error.details);
